import sc from 'styled-components';
import {ListItem} from '@phonectas/unifon-ui-kit';

export const ListItemStyled = sc(ListItem)`
    & p {
        color: #001B74 !important;
    }
`;